import React from "react";

// Phone / email of a record, whatever the screen calls the fields
export function getContact(row) {
  const pick = (keys) => {
    for (const k of keys) {
      if (row && row[k] && String(row[k]).trim() !== "") return String(row[k]).trim();
    }
    return "";
  };
  const phone = pick(["PhoneNo", "MobileNo", "Mobile", "Phone", "ContactNo", "PhoneNumber"]);
  const email = pick(["EmailID", "EmailId", "Email"]);
  const digits = phone.replace(/[^0-9]/g, "");
  return {
    phone: digits.length >= 6 ? phone : "",
    tel: digits,
    // wa.me needs the country code; local 10-digit numbers are Indian
    whatsapp: digits.length === 10 ? "91" + digits : digits,
    email: /@/.test(email) ? email : ""
  };
}

// Call / WhatsApp / Mail buttons; renders nothing without a phone or email
const ContactActions = ({ record, compact }) => {
  const contact = getContact(record);
  if (!contact.phone && !contact.email) return null;
  return (
    <div className={"contact-actions" + (compact ? " is-compact" : "")}>
      {contact.phone && (
        <a className="contact-action" href={"tel:" + contact.tel} aria-label={"Call " + contact.phone}>
          <i className="fa fa-phone" aria-hidden="true"></i>
          <span>Call</span>
        </a>
      )}
      {contact.phone && (
        <a
          className="contact-action is-whatsapp"
          href={"https://wa.me/" + contact.whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={"WhatsApp " + contact.phone}
        >
          <i className="fa fa-whatsapp" aria-hidden="true"></i>
          <span>WhatsApp</span>
        </a>
      )}
      {contact.email && (
        <a className="contact-action" href={"mailto:" + contact.email} aria-label={"Mail " + contact.email}>
          <i className="fa fa-envelope" aria-hidden="true"></i>
          <span>Mail</span>
        </a>
      )}
    </div>
  );
};

export default ContactActions;
